import { traverseAst } from "./traverse-ast.js";
const silentContext = {
  astErrorHandler: () => false
};
const stringifyAst = (ast, context = silentContext) => {
  traverseAst(ast, { after: (ast2) => {
    if (!ast2.type) {
      context.astErrorHandler(ast2, context);
      return;
    }
    switch (ast2.type) {
      case "query":
        ast2.data = `${ast2.value ? ast2.value?.data : ""}${ast2.value && ast2.orderBy ? " " : ""}${ast2.orderBy ? ast2.orderBy?.data : ""}`;
        break;
      case "terms":
        ast2.data = `terms(${ast2.value.map((value) => value.data).join(", ")})`;
        break;
      case "paren":
        ast2.data = `(${ast2.value.data})`;
        break;
      case "not":
        ast2.data = `not(${ast2.value.data})`;
        break;
      case "or":
        ast2.data = `or(${ast2.value.map((value) => value.data).join(", ")})`;
        break;
      case "and":
        ast2.data = `and(${ast2.value.map((value) => value.data).join(", ")})`;
        break;
      case "keyValue":
        ast2.data = `${ast2.key}:${ast2.value.data}`;
        break;
      case "cmp":
        ast2.data = `${ast2.key} ${ast2.op} ${ast2.value.data}`;
        break;
      case "cmpFn":
        ast2.data = `${ast2.fn}(${ast2.key}) ${ast2.op} ${ast2.value.data}`;
        break;
      case "existsFn":
        ast2.data = `exists(${ast2.key})`;
        break;
      case "inList":
        ast2.data = `${ast2.key} in (${ast2.value.map((value) => value.data).join(", ")})`;
        break;
      case "inRange":
        ast2.data = `${ast2.key} in [${ast2.value.map((value) => value.data).join(" : ")}]`;
        break;
      case "allIn":
        ast2.data = `${ast2.key} all in (${ast2.value.map((value) => value.data).join(", ")})`;
        break;
      case "text":
        ast2.data = `"${ast2.value}"`;
        break;
      case "identifier":
      case "comboundValue":
      case "value":
        ast2.data = `${ast2.value}`;
        break;
      case "orderBy":
        ast2.data = `orderBy(${ast2.value.data})${ast2.direction ? " " + ast2.direction : ""}`;
        break;
      case "orderKey":
        ast2.data = ast2.value;
        break;
      case "orderFn":
        ast2.data = `${ast2.fn}(${ast2.value})`;
        break;
      default:
        ast2.data = "";
        context.astErrorHandler(ast2, context);
    }
  } });
  return ast.data;
};
export {
  stringifyAst
};
//# sourceMappingURL=stringify-ast.js.map
